import { render, staticRenderFns } from "./PmsErpRelateTransfer.vue?vue&type=template&id=692d706d&scoped=true&"
import script from "./PmsErpRelateTransfer.vue?vue&type=script&lang=js&"
export * from "./PmsErpRelateTransfer.vue?vue&type=script&lang=js&"
import style0 from "./PmsErpRelateTransfer.vue?vue&type=style&index=0&id=692d706d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692d706d",
  null
  
)

export default component.exports